import { ArtistAlbums } from '@bpm-web-app/components/pages';
import { PageLayout } from '@bpm-web-app/components';

const ArtistAlbumsPage = () => (
    <PageLayout>
        <ArtistAlbums />
    </PageLayout>
);

export default ArtistAlbumsPage;
